// Landing page (pages#home) — the audience pop-ups and in-page navigation.
//
// Ported from the inline script in the landing.html mock-up. The mock-up's
// log-in, sign-up and access-code dialogs are gone: those are real Devise pages
// here, so the nav and card buttons link straight to them and there is no
// [data-mock-auth] form left to intercept.
//
// This is deliberately not Bootstrap's modal. The design ships its own overlay
// markup and styling, and .sf-modal is named so it cannot collide with the
// Bootstrap bundle the layout loads on every page.

function initLanding() {
  const landing = document.querySelector('.sf-landing');
  if (!landing) return;

  let lastFocus = null;

  function closeAll(keepScroll) {
    document.querySelectorAll('.sf-overlay.open').forEach((overlay) => {
      overlay.classList.remove('open');
    });

    if (keepScroll) return;

    document.body.style.overflow = '';
    if (lastFocus) {
      lastFocus.focus();
      lastFocus = null;
    }
  }

  function openModal(id) {
    const overlay = document.getElementById(id);
    if (!overlay) return;

    closeAll(true);
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';

    // The panel is the scroller; a re-opened or tall modal would otherwise keep
    // its last position, or jump to wherever focus lands.
    const panel = overlay.querySelector('.sf-modal');
    if (panel) panel.scrollTop = 0;

    const focusable = overlay.querySelector('input, select, textarea, button:not(.sf-modal-close), a');
    if (focusable) focusable.focus({ preventScroll: true });
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-open]');
    if (opener) {
      event.preventDefault();
      if (!document.querySelector('.sf-overlay.open')) lastFocus = opener;
      openModal(opener.getAttribute('data-open'));
      return;
    }

    const closer = event.target.closest('[data-close]');
    if (closer) {
      // Links with data-close still navigate to their anchor.
      const href = closer.getAttribute('href');
      closeAll();
      if (href && href.charAt(0) === '#') {
        event.preventDefault();
        const target = document.querySelector(href);
        if (target) target.scrollIntoView({ behavior: 'smooth' });
      }
      return;
    }

    // The nav is sticky, so #top sits a nav-height below the real top of the
    // document; scroll to zero instead of to the anchor.
    const toTop = event.target.closest('[data-top]');
    if (toTop) {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    if (event.target.classList.contains('sf-overlay')) closeAll();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });

  // The enquiry form posts to ContactMessagesController and the server decides
  // what to show afterwards, so there is deliberately no submit handler here.
  // Disabling the button on submit is purely to stop a double post.
  const contact = document.getElementById('contact-form');
  if (contact) {
    contact.addEventListener('submit', () => {
      const button = contact.querySelector('[type="submit"]');
      if (button) {
        button.disabled = true;
        button.value = 'Sending…';
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', initLanding);
